import {createFieldRenderer} from '../helpers';
import classNames from 'classnames';
import React from 'react';

/**
 * A renderer that doesn't wrap the factory output with any HTML.
 */
const RawFieldRenderer = createFieldRenderer(({
    factory,
    innerClassName,
    className, // Ignored
    ...props
}) => <>
    {factory({
        ...props,
        className: classNames(innerClassName),
    })}
</>);

export default RawFieldRenderer;
